import { Logger } from '@front/utils/logger';
import EventEmitter from 'events';
const DataLayerLogger = new Logger('DATALAYER', 'info');
const DataLayerEmitter = new EventEmitter();
DataLayerEmitter.setMaxListeners(30);
const DataLayer = {
    emit(event, el, originalEvent) {
        DataLayerEmitter.emit(`datalayer:${event}`, el, originalEvent);
    },
    on(event, cb) {
        DataLayerEmitter.on(`datalayer:${event}`, cb);
    },
    push(...args) {
        window.dataLayer.push(...args);
        DataLayerLogger.log('push', args);
    },
    init() {
        window.dataLayer = window.dataLayer || [];
        window.gadl = this;
    },
};
export { DataLayer };
